import { SingleTrack } from "@/components/organisms/SingleTrack";
import { Counter } from "@/features/counter/Counter";
import { Favorites } from "@/pages/Favorites";
import { Home } from "@/pages/Home";
import { Login } from "@/pages/Login";
import { PlayList } from "@/pages/Playlist";
import { Search } from "@/pages/Search";

export const routes = {
    private: [
        {
            path: "",
            name: "",
            to: "/",
            component: Home,
        },
        {
            path: '/home',
            name: 'Home',
            to: '/home',
            component: Home,
        },
        {
            path: '/playlist/:id',
            name: 'playlist',
            to: '/playlist/:id',
            component: PlayList
        },
        {
            path: '/favorites',
            name: 'Favorites',
            to: '/favorites',
            component: Favorites,
        },
        {
            path: '/search',
            name: 'Search',
            to: '/search',
            component: Search,
        },
        {
            path: '/single/:id',
            name: 'Single',
            to: '/single',
            component: SingleTrack,
        }
    ],
    public: [
        {
            path: '/',
            name: 'Login',
            to: '/',
            component: Login
        },
        {
            path: '/counter',
            name: 'Counter',
            to: '/counter',
            component: Counter
        }
    ]
}